var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-template',{attrs:{"loading":_vm.loading,"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"current-page":_vm.page,"has-back":""},on:{"onSearch":_vm.onSearch,"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleEdit,"onReset":_vm.onReset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }